import React from 'react';
import { CaseStudy } from '../types';
import { CaseStudyCard } from './CaseStudyCard';

interface CaseStudyGridProps {
  caseStudies: CaseStudy[];
  activeDiscipline: string | null;
  onFilterChange: (disciplineId: string | null) => void;
}

export const CaseStudyGrid: React.FC<CaseStudyGridProps> = ({
  caseStudies,
  activeDiscipline,
  onFilterChange,
}) => {
  const filteredStudies = activeDiscipline
    ? caseStudies.filter((c) => c.discipline_id === activeDiscipline)
    : caseStudies;

  return (
    <section id="work" className="case-study-section">
      <div className="container">
        <div className="section-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: '1rem' }}>
          <div>
            <span className="section-tag">Featured Work</span>
            <h2 className="section-title">Case Studies & Architecture</h2>
          </div>

          <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
            <button
              onClick={() => onFilterChange(null)}
              className={`btn ${activeDiscipline === null ? 'btn-primary' : 'btn-secondary'}`}
              style={{ padding: '0.4rem 1rem', fontSize: '0.85rem' }}
            >
              All Work ({caseStudies.length})
            </button>
            <button
              onClick={() => onFilterChange('cloud')}
              className={`btn ${activeDiscipline === 'cloud' ? 'btn-primary' : 'btn-secondary'}`}
              style={{ padding: '0.4rem 1rem', fontSize: '0.85rem' }}
            >
              Cloud & Security
            </button>
            <button
              onClick={() => onFilterChange('music')}
              className={`btn ${activeDiscipline === 'music' ? 'btn-primary' : 'btn-secondary'}`}
              style={{ padding: '0.4rem 1rem', fontSize: '0.85rem' }}
            >
              Classical Remix
            </button>
            <button
              onClick={() => onFilterChange('maker')}
              className={`btn ${activeDiscipline === 'maker' ? 'btn-primary' : 'btn-secondary'}`}
              style={{ padding: '0.4rem 1rem', fontSize: '0.85rem' }}
            >
              Hardware & Events
            </button>
          </div>
        </div>

        <div className="case-study-grid">
          {filteredStudies.map((cs) => (
            <CaseStudyCard key={cs.id} caseStudy={cs} />
          ))}
        </div>
      </div>
    </section>
  );
};
